module.exports = __webpack_public_path__ + "static/media/new-scientist.a72d9fc5.jpg";